import "normalize.css";
import "./index.less";

import "SITE/vendors/polyfill";

import Ripple from "./ripple";

const nav = document.getElementById("nav-more");
// const icon = document.getElementsByClassName('u-icon-nav')[0];
const next = document.getElementById("slide-next");
const logo = document.getElementsByClassName("m-logo")[0];
// const els = [nav, icon, next];
const els = [nav, next];
/* SCROLL SLIDE */
const slides = new Scroll({
  viewport: document.getElementById("slider"),
  slides: document.querySelectorAll("#slider>section"),
  aniDuration: 0.1,
  paginator: "right",
  onScroll,
});

document.getElementsByClassName("scroll-slide-paginator")[0].style.right =
  "3rem";
document.getElementById("slide-next").addEventListener("click", () => {
  slides.scrollDown();
});
const dots = document.getElementsByClassName("scroll-slide-paginator-dot");

/* SWIPER */
const swiper = new Swiper(".swiper-container", {
  init: false,
  loop: true,
  pagination: ".swiper-pagination",
  paginationClickable: true,
  autoplay: 4000,
  autoplayDisableOnInteraction: false,
  effect: "fade",
  onTransitionStart(swiper) {
    onSwipe(swiper.realIndex);
  },
});
swiper.init();

/* SWIPER */
const swiper1 = new Swiper(".swiper-container1", {
  init: false,
  loop: true,
  pagination: ".swiper-pagination",
  paginationClickable: true,
  autoplay: 4000,
  autoplayDisableOnInteraction: false,
  effect: "fade",
  onTransitionStart(swiper) {
    onSwipe(swiper.realIndex);
  },
});
swiper1.init();

// slides.scrollTo(1); // debug purpose

const swiperList = document.querySelectorAll(".swiper-wrapper");
const swiperImgList = document.querySelectorAll(".m-swiper-slide-img");

const ratio = 16 / 9;

/* CANVAS */
const slide2Info = {
  color: "229,0,39",
  curvePoints: [
    {
      ox: 815,
      oy: 410,
      ocp1x: 670,
      ocp1y: 185,
      ocp2x: 780,
      ocp2y: 285,
      align: "left",
      text: "野人体能",
      url: "/programme/skill",
    },
    {
      ox: 715,
      oy: 750,
      ocp1x: 865,
      ocp1y: 610,
      ocp2x: 750,
      ocp2y: 725,
      align: "left",
      text: "研学超人",
      url: "/programme/superman",
    },
    {
      ox: 290,
      oy: 750,
      ocp1x: 620,
      ocp1y: 850,
      ocp2x: 390,
      ocp2y: 850,
      align: "right",
      text: "佳音英语",
      url: "/programme/joy",
    },
    {
      ox: 190,
      oy: 410,
      ocp1x: 255,
      ocp1y: 725,
      ocp2x: 145,
      ocp2y: 610,
      align: "right",
      text: "野人营地",
      url: "/programme/camp",
    },
    {
      ox: 505,
      oy: 175,
      ocp1x: 235,
      ocp1y: 275,
      ocp2x: 330,
      ocp2y: 185,
      align: "bottom",
      text: "3S自学成长营",
      url: "/programme/threes",
    },
  ],
};
const defaultSlide2MousePos = {
  x: -1000,
  y: 0,
};

class Canvas {
  constructor() {
    this.ripple = null;
    this.canvas = null;
    this.width = 0;
    this.height = 0;
  }

  init(canvas) {
    this.canvas = canvas;
    this.resize();
    if (this.canvas.getContext) {
      this.width = this.canvas.getAttribute("width");
      this.height = this.canvas.getAttribute("height");
      this.ripple = new Ripple({
        canvas: this.canvas,
        info: slide2Info,
        mousePos: { ...defaultSlide2MousePos },
        radius: 200, // 感应半径
        ratio: this.width / 1006,
      });
    }
  }

  resize() {
    this.canvas.setAttribute("width", this.canvasSize());
    this.canvas.setAttribute("height", this.canvasSize());
  }

  canvasSize() {
    return window.innerWidth > window.innerHeight * 0.9
      ? window.innerHeight * 0.9
      : window.innerWidth * 0.9;
  }

  getPosOfCanvas(x, y) {
    const rect = this.canvas.getBoundingClientRect();
    return {
      x: x - rect.left,
      y: y - rect.top,
    };
  }

  getPosOfWindow(x, y) {
    const rect = this.canvas.getBoundingClientRect();
    return {
      x: x + rect.left,
      y: y + rect.top,
    };
  }
}

const canvas = document.getElementById("canvas");
const c = new Canvas();
c.init(canvas);

function throttle(method, context) {
  clearTimeout(method.tId);
  method.tId = setTimeout(() => {
    method.call(c, context);
  }, 16);
}

if (window.addEventListener) {
  window.addEventListener("resize", (e) => {
    for (let i = 0; i < swiperList.length; ++i) {
      swiperList[i].style.height = `${window.innerHeight}px`;
    }

    const w = window.innerWidth;
    const h = window.innerHeight;
    if (w / h > ratio) {
      let offset = Math.ceil((w / ratio - h) / 2);
      Array.prototype.forEach.call(swiperImgList, (s) => {
        s.style.width = `${w}px`;
        s.style.height = "auto";
        s.style.marginTop = `-${offset}px`;
      });
    } else {
      let offset = Math.ceil((h * ratio - w) / 2);
      Array.prototype.forEach.call(swiperImgList, (s) => {
        s.style.width = "auto";
        s.style.height = `${h}px`;
        s.style.marginLeft = `-${offset}px`;
      });
    }
  });
} else {
  console.log("The browser does not support Javascript event binding");
}

function onSwipe(i) {
  switch (i) {
    case 0:
      nav.classList.add("u-text-dark");
      // icon.classList.add('u-text-dark');
      Array.prototype.forEach.call(dots, (d) => {
        d.classList.add("invert");
      });
      break;
    default:
      nav.classList.remove("u-text-dark");
      // icon.classList.remove('u-text-dark');
      Array.prototype.forEach.call(dots, (d) => {
        d.classList.remove("invert");
      });
      break;
  }
}

function onScroll(i) {
  const nextEle = document.querySelector("#slide-next");
  if (i === 3) {
    nextEle.style.display = "none";
  } else {
    nextEle.style.display = "block";
  }
  console.log("eeeeeeeeeeeeeeeeee", i);
  switch (i) {
    case 0:
      swiper.slideTo(0);
    case 1:
    case 4:
      els.forEach((e) => {
        e.classList.remove("u-text-dark");
      });
      Array.prototype.forEach.call(dots, (d) => {
        d.classList.remove("invert");
      });
      break;
    case 2:
    case 3:
      els.forEach((e) => {
        e.classList.add("u-text-dark");
      });
      Array.prototype.forEach.call(dots, (d) => {
        d.classList.add("invert");
      });
      break;
    default:
      break;
  }
  switch (i) {
    case 1:
      next.classList.remove("u-hidden");
      logo.classList.add("u-text-light");
      break;
    case 3:
      next.classList.remove("u-hidden");
      logo.classList.add("u-text-light");
      break;
    case 4:
      next.classList.add("u-hidden");
      logo.classList.add("u-text-light");
      break;
    default:
      next.classList.remove("u-hidden");
      logo.classList.remove("u-text-light");
      break;
  }
  /* 控制首页 SWIPER 播放 */
  switch (i) {
    case 0:
      swiper.slideTo(1);
      swiper.startAutoplay();
      break;
    default:
      swiper.stopAutoplay();
      break;
  }
  /* 动画 */
  switch (i) {
    case 2:
      animeSlide3();
      break;
    case 3:
      animeSlide4();
      break;
    case 4:
      animeSlide5();
    default:
      break;
  }
}

function animeSlide3() {
  /* 数字累加动画 */
  const wrapper = document.getElementById("anime-count-up");
  if (!wrapper) return;
  const count = { value: 0 };
  anime({
    targets: count,
    value: 1000000,
    easing: "linear",
    duration: 1500,
    update() {
      if (wrapper) {
        wrapper.innerHTML = "";
      }
      const tmp = Math.floor(count.value).toString().split("");
      for (let i = 0; i < tmp.length; ++i) {
        if (i === tmp.length - 3 || (i === tmp.length - 6 && tmp.length > 6)) {
          const dot = document.createElement("span");
          dot.innerHTML = ",";
          dot.classList.add("dot");
          wrapper.appendChild(dot);
        }
        const el = document.createElement("span");
        el.innerHTML = tmp[i];
        wrapper.appendChild(el);
      }
      const plus = document.createElement("span");
      plus.innerHTML = "+";
      wrapper.appendChild(plus);
    },
  });
}

function animeSlide4() {
  const timeline = anime.timeline();

  timeline
    .add({
      targets: "#anime-flip-in-x",
      delay: 250,
      easing: "linear",
      perspective: "400px",
      rotateX: ["90deg", "-20deg", "10deg", "-5deg", 0],
    })
    .add({
      targets: "#anime-fade-in-1",
      duration: 200,
      opacity: [0, 1],
    })
    .add({
      targets: "#anime-fade-in-2",
      duration: 200,
      opacity: [0, 1],
    })
    .add({
      targets: "#anime-fade-in-3",
      duration: 200,
      opacity: [0, 1],
    })
    .add({
      targets: "#anime-fade-in-4",
      duration: 200,
      opacity: [0, 1],
    });

  anime({
    targets: "#anime-fade-in-left",
    delay: 1000,
    easing: "easeOutCirc",
    elasticity: 500,
    opacity: [0, 1],
    translateX: ["-100%", 0],
  });
}

function animeSlide5() {
  anime.remove("#anime-width");
  anime({
    targets: "#anime-width",
    easing: "easeOutCirc",
    delay: 500,
    duration: 5000,
    width: [0, 345],
  });
}
